// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-redeclare
/* globals jQuery, require, $ */

import "../sass/theme.scss";
// import "../sass/landing.scss";

import svgxhr from "webpack-svgstore-plugin/src/helpers/svgxhr";
import AnimateScroll from "./modules/AnimateScroll";
import { default as GetInTouch, search as Search } from "./modules/forms";
import Accordion from "./modules/accordion";
import ProcessSwiper from "./modules/process-swiper";
import RangeSlider from "./modules/range-slider";
import VerticalSwiper from "./modules/vertical-swiper";
import HomeHeader from "./modules/home-header";
import Nav from "./modules/nav";
import Charts from "./modules/charts";
import Landing from "./landing";
import Footer from "./modules/footer";
import TestimonialSwiper from "./modules/testimonial-swiper";
import "remodal";

const chosen = require("chosen-js");

window.prosperity = {
  init() {
    Landing.init();
    Nav.init();
    VerticalSwiper.init();
    RangeSlider.init();
    ProcessSwiper.init();
    HomeHeader.init();
    Accordion.init();
    GetInTouch.init();
    Search.init();
    Charts.init();
    Footer.init();
    HomeHeader.init();
    TestimonialSwiper.init();

    const animateScroll = new AnimateScroll();
    animateScroll.init();

    // if an element called form-scroll exists then a testimonial block has been
    // previously set.
    const testimonial_form_submitted = document.querySelector(".form-scroll");
    if (testimonial_form_submitted) {
      testimonial_form_submitted.scrollIntoView({ block: "end" });
    }

    /** Removing any hash e.g. #let-us-help when we are on a thank you template. */
    if (document.body.classList.contains("page-template-thank-you")) {
      history.replaceState(null, null, " ");
      $(document).on("opened", ".remodal", (e) => {
        console.log("Modal is opening");
        document.querySelector(".remodal-close").click();
      });
    }

    $("select:not(.default-select)").chosen({ disable_search_threshold: 9999 });

    // Allow user to interrupt auto-scrolling
    $(document).bind("scroll mousedown wheel keyup", (e) => {
      if (e.which || e.type === "mousedown" || e.type === "mousewheel") {
        $(document.scrollingElement).stop();
      }
    });

    const inst = $('[data-remodal-id="thank-you"]').remodal();
    window.addEventListener("open.thanks", () => {
      inst.open();
    });

    const dbsInst = $('[data-remodal-id="dbs-modal"]').remodal();
    window.addEventListener("open.dbs", () => {
      dbsInst.open();
    });
  },
  helpers: {
    requireAll(r) {
      r.keys().forEach(r);
    },
    initSvg() {
      svgxhr({
        filename: "./wp-content/themes/class/dist/sprite.svg", // URL to fetch
      });
    },
  },
};

$(() => {
  window.prosperity.init();
});

if (typeof NodeList.prototype.forEach !== "function") {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// SVG Sprite Loader
window.prosperity.helpers.requireAll(require.context("../images/icons/", true, /\.svg$/));

//
// // SVG Sprite Loader
// // eslint-disable-next-line no-unused-vars,@typescript-eslint/naming-convention
// const __svg__ = {
//   path: "../../resources/images/icons/**/*.svg", // Source SVGs path relative to the compiled js (dist/js)
//   name: "images/icons.svg", // Compiled file path relative to dist/
// };
//
// svgxhr({
//   filename: "./wp-content/themes/class/dist/images/icons.svg", // URL to fetch
// });
